import { createMemoryHistory, createWebHistory, createRouter as _createRouter } from 'vue-router'
import component from './App.vue'

const routes = [
  { path: '/', redirect: { name: 'home' } },
  {
    path: '/bolig/', component, name: 'home', meta: {
      product: 'Bolig',
      title: 'Lån og forsikring til bolig | FINN økonomi',
      description: 'Bruk lånekalkulatoren vår for å se hva boliglånet vil koste hos forskjellige banker. Se hvem som kan tilby hus, innboforsikring eller søk boliglån hos flere banker.'
    }
  },
  {
    path: '/bil/', component, name: 'car', meta: {
      product: 'Bil',
      title: 'Lån og forsikring til bil | FINN økonomi',
      description: 'Bruk lånekalkulatoren vår for å se hva billånet vil koste hos forskjellige banker. Se hvem som kan tilby bilforsikring eller søk billån hos flere banker samtidig.'
    }
  },
  {
    path: '/bat/', component, name: 'boat', meta: {
      product: 'Båt',
      title: 'Lån og forsikring til båt | FINN økonomi',
      description: 'Bruk lånekalkulatoren vår for å se hva båtlånet vil koste hos forskjellige banker. Se hvem som kan tilby deg båtforsikring.'
    }
  },
  {
    path: '/mc/', component, name: 'motorcycle', meta: {
      product: 'MC',
      title: 'Lån og forsikring til MC | FINN økonomi',
      description: 'Bruk lånekalkulatoren vår for å se hva MC-lånet vil koste hos forskjellige banker. Se hvem som kan tilby deg MC-forsikring.'
    }
  }
]

const base = '/okonomi'

export function createRouter(isSSR) {
  return _createRouter({
    routes,
    history: isSSR ? createMemoryHistory(base) : createWebHistory(base)
  })
}
